import React, { useRef, useEffect, useState } from "react";

const DynamicIframe = ({ src, title, className, style }) => {
  const iframeRef = useRef(null);
  const [height, setHeight] = useState("900px");

  useEffect(() => {
    const iframe = iframeRef.current; // Hello
    if (!iframe) return;

    const adjustHeight = () => {
      try {
        const contentHeight = iframe.contentWindow.document.body.scrollHeight;
        const newHeight = Math.max(contentHeight, 900);

        setHeight(`${newHeight}px`);
      } catch (error) {
        setHeight("900px");
      }
    };

    iframe.onload = adjustHeight;

    const handleMessage = (event) => {
      if (event.data && event.data.type === "resize") {
        setHeight(`${event.data.height}px`);
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [src]);

  return (
    <iframe
      ref={iframeRef}
      src={src}
      title={title}
      className={className}
      style={{
        ...style,
        height: height,
        minHeight: "900px",
      }}
    />
  );
};

export default DynamicIframe;

// The following is an example of how to use the DynamicIframe component(which is used in the plot container):

//  <DynamicIframe
//     src={plotUrl}
//     title={title}
//     className="custom-scroll"
//     style={{
//     width: "100%",
//     border: "none",
//     borderRadius: "0 0 6px 6px",
//     }}
// />
